import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";
import { get } from "lodash";
import "react-image-gallery/styles/css/image-gallery.css";
import "./thumbnailGallery.scss";
import { Image, Modal } from "semantic-ui-react";
import ProductInfoItem from "builder_portal/components/product/ProductInfoItem";
import { Magnifier } from "react-image-magnifiers";

class ThumbnailGallery extends PureComponent {
  static propTypes = {
    option: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      startIndex: 0,
      thumbnailPosition: "right"
    };
  }

  onOrientationChange = () => {
    let thumbnailPosition;

    if (get(screen, "orientation.type")) {
      if (screen.orientation.type.includes("landscape")) {
        thumbnailPosition = "right";
      } else if (screen.orientation.type.includes("portrait")) {
        thumbnailPosition = "bottom";
      } else {
        console.warn("could not determine screen.orientation.type");
        thumbnailPosition = "right"; // Default
      }
    } else {
      // extrawurst for SafariIOs since it has not implemented ScreenOrientationType yet (https://caniuse.com/#feat=screen-orientation)
      // Use bitwise orientation-magic (http://www.codecouch.com/2011/11/detecting-orientation-changes-in-mobile-safari-on-ios-and-other-supported-browsers/)
      if (window.orientation & 2) {
        // landscape mode
        thumbnailPosition = "right";
      } else {
        // portrait mode
        thumbnailPosition = "bottom";
      }
    }
    this.setState({ thumbnailPosition });
  };

  componentDidMount() {
    window.addEventListener(
      "orientationchange",
      this.onOrientationChange,
      false
    );
    this.onOrientationChange(); // initial state
  }

  componentWillUnmount() {
    window.removeEventListener(
      "orientationchange",
      this.onOrientationChange,
      false
    );
  }

  render() {
    const { option } = this.props;

    return (
      <div key={option.id} data-component="image-gallery">
        {this.renderThumbnailImageGroup()}
        {this.renderGalleryModal()}
      </div>
    );
  }

  renderGalleryItem = item => {
    // re-render MagnifierComponent,
    // sets zoom-in cursor CSS-class
    // resets Zoomed-In state
    const refreshKey = Date.now();

    return (
      <div className="image-gallery-image">
        {
          <Magnifier
            key={refreshKey}
            dragToMove={false}
            imageSrc={item.large || item.original}
            imageAlt={item.original}
            largeImageSrc={item.original}
          />
        }
        {item.description && (
          <span className="image-gallery-description">{item.description}</span>
        )}
      </div>
    );
  };

  renderYoutubeItem = ({ embedUrl }) => {
    return (
      <div className="image-gallery-image">
        <iframe
          style={{ width: "820px", height: "576px" }}
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  };

  optionImageToGalleryItem = ({ service, id, url }) => {
    if (service === "youtube") {
      return {
        original: `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`,
        thumbnail: `https://i.ytimg.com/vi/${id}/default.jpg`,
        embedUrl: `https://www.youtube.com/embed/${id}`,
        renderItem: this.renderYoutubeItem
      };
    }
    return {
      // Paperclip creates several versions of the original, we dirty-pick the quality of need
      medium: url,
      large: url.replace("/medium/", "/large/"),
      original: url.replace("/medium/", "/original/"),
      thumbnail: url.replace("/medium/", "/thumb/"),
      renderItem: this.renderGalleryItem
    };
  };

  optionImageToThumbnailItem = ({ service, id, url }, i) => {
    let backgroundImage;
    if (service === "youtube") {
      backgroundImage = `url("https://i.ytimg.com/vi/${id}/default.jpg")`;
    } else {
      backgroundImage = `url("${url.replace("/medium/", "/thumb/")}")`;
    }

    return (
      <Image
        key={`${id}-${url}`}
        className="thumb"
        // Paperclip creates several versions of the original, we dirty-pick the quality of need
        style={{ backgroundImage }}
        onClick={e => {
          e.stopPropagation();
          this.setState({ modalOpen: true, startIndex: i });
        }}
      />
    );
  };

  renderGalleryModal() {
    const { modalOpen, thumbnailPosition, startIndex } = this.state;
    const { option } = this.props;
    const { images } = option;
    const galleryItems = images.map(this.optionImageToGalleryItem);

    return (
      <Modal
        closeIcon
        closeOnDimmerClick={false}
        size="large"
        open={modalOpen}
        onClose={event => {
          event.stopPropagation();
          this.setState({ modalOpen: false });
        }}
      >
        <Modal.Header>
          <ProductInfoItem product={option} mode="compact" />
        </Modal.Header>
        <Modal.Content style={{ height: "80vh" }}>
          <ImageGallery
            startIndex={startIndex}
            showPlayButton={false}
            slideDuration={0}
            showFullscreenButton={false}
            thumbnailPosition={thumbnailPosition}
            items={galleryItems}
          />
        </Modal.Content>
      </Modal>
    );
  }

  renderThumbnailImageGroup() {
    const { option } = this.props;
    const { images } = option;
    return (
      <div data-component="thumbnail-gallery">
        <Image.Group>{images.map(this.optionImageToThumbnailItem)}</Image.Group>
      </div>
    );
  }
}

export default ThumbnailGallery;
